module.exports = __webpack_public_path__ + "static/img/avatar-default.37c3ea6b.png";